import React from 'react';

import { DASH, localDate, statusChipClass, STATUS_APPROVED, STATUS_REJECTED } from './changeRequestFormat';

const chipClassFor = (status) =>
    ({
        submitted: 'bc-chip bc-chip--grey',
        not_reached: 'bc-chip bc-chip--grey',
        not_due: 'bc-chip bc-chip--grey',
        withdrawn: 'bc-chip bc-chip--grey',
        approved: statusChipClass(STATUS_APPROVED),
        rejected: statusChipClass(STATUS_REJECTED),
    })[status] ?? statusChipClass(null);

/**
 * The submission, then each approver's decision, in the order they happened. Read
 * off the row's `history`, which the server builds for both pop-ups.
 */
export default function ApprovalHistoryTable({ history }) {
    if (!history?.length) {
        return null;
    }

    return (
        <div>
            <div className="bc-eyebrow">{$t('Approval History')}</div>
            <div className="inbud-table_wrapper bc-table-wrapper">
                <table className="inbud-table bc-table">
                    <thead>
                        <tr>
                            <th>{$t('Who')}</th>
                            <th>{$t('Date')}</th>
                            <th>{$t('Action')}</th>
                            <th>{$t('Comments')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {history.map((entry, index) => (
                            <tr key={index}>
                                <td>{entry.who}</td>
                                <td className="tw-whitespace-nowrap">{localDate(entry.at)}</td>
                                <td className="tw-whitespace-nowrap">
                                    <span className={chipClassFor(entry.status)}>{entry.action}</span>
                                </td>
                                <td className="tw-whitespace-pre-wrap tw-break-words tw-text-charcoal-75">{entry.comments || DASH}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
